import API_CONFIG from '../config/api';
import {fetchAuthSession} from 'aws-amplify/auth';

export interface PivotLevelStats {
  timeframe: string;
  levelType: string;
  totalInteractions: number;
  touchCount: number;
  bounceCount: number;
  breakCount: number;
  bullishBreakCount: number;
  bearishBreakCount: number;
  rejectionCount: number;
  successRate: number;  // Decimal 0.0-1.0 (multiply by 100 for percentage display)
  averageDistance: number;
  averageStrengthScore: number;  // Decimal 0.0-1.0 (multiply by 100 for percentage display)
  reliabilityGrade: string;  // A, B, C, D, or F
}

export interface PivotLevelStatsResponse {
  productId: string;
  lookbackDays: number;
  stats: PivotLevelStats[];
  timestamp: string;
}

export interface PivotLevelStatsParams {
  productId: string;
  lookbackDays?: number;
}

async function getAuthToken(): Promise<string | undefined> {
  try {
    const session = await fetchAuthSession();
    return session.tokens?.idToken?.toString();
  } catch (error) {
    console.error('Failed to get auth token:', error);
    return undefined;
  }
}

export async function getPivotLevelStats(params: PivotLevelStatsParams): Promise<PivotLevelStatsResponse> {
  const queryParams = new URLSearchParams({
    productId: params.productId,
    ...(params.lookbackDays && { lookbackDays: params.lookbackDays.toString() }),
  });

  const url = `${API_CONFIG.baseUrl}/v1/pivot-intelligence/level-stats?${queryParams}`;

  const token = await getAuthToken();

  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
    },
  });

  if (!response.ok) {
    const errorText = await response.text();
    console.error('Pivot level stats API error:', response.status, errorText);
    throw new Error(`Failed to fetch pivot level stats: ${response.status} ${response.statusText}`);
  }

  return await response.json();
}

